import * as Sentry from "@sentry/browser";

import { useSavedGroupsState } from "./SavedGroupsContext/SavedGroupsContext";

// Algolia rejects a `filters` string past ~1000 combined clauses, so the objectID OR below caps the
// saved list at that limit (and reports the overflow) rather than let it fail the whole query once a
// viewer saves that many of one type.
const ALGOLIA_MAX_FILTER_CLAUSES = 1000;

// Builds the Algolia `filters` string that restricts a search tab to the viewer's saved sources
// of a single type (any member of Interact::Favorite::GROUPABLE_TYPES). Returns null when the
// "Saved" toggle is off (no filtering); when it's on but the viewer has saved none, returns an
// impossible objectID so the tab shows nothing rather than everything.
export default function useSavedOnlyFilter(savedOnly, sourceableType) {
  const savedGroupsState = useSavedGroupsState();
  if (!savedOnly) return null;

  const savedIds = Object.keys(savedGroupsState?.membershipIndex?.[sourceableType] || {});
  if (savedIds.length === 0) return "objectID:-1";

  let ids = savedIds;
  if (savedIds.length > ALGOLIA_MAX_FILTER_CLAUSES) {
    Sentry.captureMessage(
      `Saved-only filter for ${sourceableType} has ${savedIds.length} ids, over Algolia's ~${ALGOLIA_MAX_FILTER_CLAUSES}-clause limit; truncating`,
      "warning",
    );
    ids = savedIds.slice(0, ALGOLIA_MAX_FILTER_CLAUSES);
  }

  return ids.map((id) => `objectID:${id}`).join(" OR ");
}
